import React from "react";
import "./SandFilling.css";

const SandFilling = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ducimus,
        inventore.
      </h1>
    </div>
  );
};

export default SandFilling;
